import { render } from "./vresourcesexamine.vue?vue&type=template&id=05f68bc4&scoped=true"
import script from "./vresourcesexamine.vue?vue&type=script&lang=js"
export * from "./vresourcesexamine.vue?vue&type=script&lang=js"

import "./vresourcesexamine.vue?vue&type=style&index=0&id=05f68bc4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f68bc4"]])

export default __exports__